import { StyleSheet } from 'react-native'
import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  flex: {
    flex: 1
  },
  white: {
    color: 'white'
  },
  headerText: {
    fontSize: 18
  },
  padding: {
    paddingHorizontal: 16
  },
  scroll: theme => ({
    backgroundColor: theme.colors.backgroundColor
  }),
  title: {
    fontWeight: 'bold',
    fontSize: Fonts.size.h4
  },
  subtitle: {
    fontSize: 16
  },
  card: theme => ({
    borderRadius: 5,
    borderWidth: 1,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderColor: Colors.blue_two
  }),
  paddingTop: x => {
    return { paddingTop: x * 4 }
  },
  paddingBottom: x => {
    return { paddingBottom: x * 4 }
  },
  headerDescription: {
    fontSize: 24,
    marginLeft: -1,
    marginRight: 10
  },
  subHeader: {
    marginTop: 8,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },
  continueBtn: {
    marginBottom: 12
  },
  nameModalContent: {
    paddingBottom: 112,
    paddingVertical: 16
  },
  nameModalText: {
    paddingHorizontal: 16
  },
  nameHeader: {
    fontSize: 20,
    fontWeight: 'bold',
    paddingBottom: 16
  },
  nameDesc: {
    fontSize: 16,
    paddingBottom: 24
  },
  nameForm: {
    padding: 16,
    borderWidth: 1,
    borderRadius: 8,
    paddingBottom: 42,
    borderColor: '#F2F2F2'
  },
  nameLabel: {
    fontSize: 18,
    fontWeight: 'bold'
  },
  nameSubLabel: {
    fontSize: 16
  },
  formHeader: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: 6
  },
  icon: {
    marginRight: 16
  },
  divider: {
    marginTop: 16,
    marginBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#EBEBEB'
  },
  headerContent: {
    // paddingTop: 24,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between'
  },
  headerContainer: {
    paddingVertical: 16,
    paddingHorizontal: 16
  },
  headerTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
})

export default styles
